import { FC, useRef } from "react";
import { useStaffMode } from "../../../hooks/StaffModeProvider";

interface StickyCardProps {
  children: React.ReactNode;
  title: string;
  titleClassName?: string;
  offset?: number;
}

const StickyCard: FC<StickyCardProps> = ({
  children,
  title,
  titleClassName,
}) => {
  const { isStaffMode } = useStaffMode();
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={containerRef} className="flex flex-col w-full bg-white">
      <div
        className={`sticky top-0 z-10  ${isStaffMode ? "bg-secondary" : "bg-primary"} shadow-md flex items-center justify-between`}
      >
        {title && (
          <div
            className={`${titleClassName ?? ""} text-white text-lg md:text-xl lg:text-2xl font-decimal font-medium p-4 lg:p-6`}
          >
            {title}
          </div>
        )}
      </div>

      <div className="p-4 lg:p-6 gap-4 lg:gap-6 w-full max-w-full">
        {children}
      </div>
    </div>
  );
};

export default StickyCard;
